import { put, takeLatest, call } from 'redux-saga/effects';
import Pagination from '../interfaces/common/pagination';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';
import { PayloadAction } from '@reduxjs/toolkit';
import Paging from '../interfaces/common/paging';
import { fetchOrderSourceByIdError, fetchOrderSourceByIdSuccess, fetchOrderSourcesError, fetchOrderSourcesSuccess } from '../reducers/orderSourceReducer';
import OrderSourceApi from '../api/orderSourceApi';
import OrderSource from '../interfaces/output/orderSource';

function* doFetchOrderSource(action: PayloadAction<string>) {
    const customerId = action.payload;
    try {
        const response: OrderSource = yield call(OrderSourceApi.fetchOrderSourceById, customerId);
        yield put(fetchOrderSourceByIdSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchOrderSourceByIdError(error as HttpErrorResponse));
    }
}

function* doFetchOrderSources(action: PayloadAction<{ paging: Paging}>) {
    const { paging } = action.payload;
    try {
        const response: Pagination<OrderSource> = yield call(OrderSourceApi.fetchOrderSources, paging);
        yield put(fetchOrderSourcesSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchOrderSourcesError(error as HttpErrorResponse));
    }
}

export default [
    takeLatest('orderSource/fetchOrderSourceById', doFetchOrderSource),
    takeLatest('orderSource/fetchOrderSources', doFetchOrderSources)
];

